// extracted by mini-css-extract-plugin
export var dropdown = "_uj-0";
export var imageWrapper = "_uj-3";
export var itemNameContainer = "_uj-1";
export var productImage = "_uj-2";
export var spinnerWrapper = "_uj-4";